import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  filteredByProjects,
  resetFilters,
} from "../../../features/projects/projectsSlice";

const ProjectItem = ({ project }) => {
  const [isChecked, setIsChecked] = useState(true);

  const { projectName, colorClass } = project || {};

  const dispatch = useDispatch();

  const handleChange = (e) => {
    setIsChecked(e.target.checked);
    if (!e.target.checked) {
      dispatch(filteredByProjects(projectName));
    } else {
      dispatch(resetFilters(projectName));
    }
  };

  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={`${colorClass}`}
        checked={isChecked}
        onChange={handleChange}
      />
      <p className="label">{projectName}</p>
    </div>
  );
};

export default ProjectItem;
